/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Code_FormatInputs */

const vi_validation_code_format = /** @type {(inputs: Validation_Code_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã chỉ chứa chữ hoa, số và dấu gạch dưới`)
};

/**

* @param {Validation_Code_FormatInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_code_format = /** @type {((inputs?: Validation_Code_FormatInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Code_FormatInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_code_format(inputs)
});